import { insertOrUpdateBlock } from "@blocknote/core";
import type { DefaultReactSuggestionItem } from "@blocknote/react";
import type { BnEditor } from "blocks-schema";
import { Icon, iconStyles } from "ui";

export function insertPageBlockItems(editor: BnEditor): DefaultReactSuggestionItem[] {
  return [
    {
      title: "Page Link",
      onItemClick: () =>
        insertOrUpdateBlock(editor, {
          type: "pageBlock",
          props: {
            pageId: "", // This would be replaced with an actual PersistedPage object
          },
        }),
      aliases: ["page"],
      group: "Content",
      icon: <Icon className={iconStyles.neutral600} iconType="PageBlock" />,
      subtext: "Nested page",
    },
  ];
}
